module.exports = __webpack_public_path__ + "img/william-still.6b709100.png";